export default "__VITE_ASSET__c7a210af__"